export var ValueGedcomForm;
(function (ValueGedcomForm) {
    ValueGedcomForm["LineageLinked"] = "LINEAGE-LINKED";
})(ValueGedcomForm || (ValueGedcomForm = {}));
//# sourceMappingURL=ValueGedcomForm.js.map